import * as Sentry from '@sentry/browser';
import { errorReset, httpError } from './errorHandlerSlice';

export const handleHTTPError = (error: any, dispatch: AppDispatch) => {
  const response = error?.response ?? {};
  const data = response?.data ?? {};

  const errorMessageFromAction = error?.action?.actionData?.errorMessage;
  const correlationId = error?.correlationId;
  const type = error?.type as string | undefined;

  let message = data?.message || errorMessageFromAction || '';
  const errCode = data?.code as string | number | undefined;

  try {
    const sentryMsg = message || 'HTTP Error';
    Sentry.captureMessage({ ...message, correlationId });
  } catch {}

  if (error?.action?.params === 'skipErrorModal') {
    message = '';
  }
  dispatch(
    httpError({
      msg: message,
      errorCode: errCode,
      correlationId,
    }),
  );
};
